import { FloatingTrigger } from "@faire/slate/private/floating/FloatingTrigger";
import React from "react";

/**
 * Trigger component for the menu.
 *
 * The child of this component must forward props to the underlying HTML element.
 *
 * ```tsx
 * <MenuTrigger>
 *   <MyCustomButton myCustomProps="myCustomProps">Open Menu</MyCustomButton>
 * </MenuTrigger>
 *
 * const MyCustomButton = ({ myCustomProps, ref, ...props }) => {
 *   return <button {...props} ref={ref} >Open Menu</button>;
 * };
 * ```
 */
export const MenuTrigger: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  return <FloatingTrigger>{children}</FloatingTrigger>;
};
